import { Controller } from "@hotwired/stimulus"

// A form sent as soon as one of its fields changes: picking a file to add, or a logo for a place.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
